import { render } from "./noupload.vue?vue&type=template&id=84e37f0e&scoped=true"
import script from "./noupload.vue?vue&type=script&lang=js"
export * from "./noupload.vue?vue&type=script&lang=js"

import "./noupload.vue?vue&type=style&index=0&id=84e37f0e&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84e37f0e"]])

export default __exports__